import type { TFunction } from 'i18next'
import SocialShare, {
  getModelShareLink,
  SystemShareButton,
} from 'src/components/SocialShare/SocialShare'
import { UIDialog } from 'src/components/ui/Modal'
import type { GenerationModelDetailFragment } from 'src/services/apollo/generated/graphql'
import { getPublicUrl } from 'src/utils/media'
import { getUserDisplayName } from 'src/utils/user'

export type ModelForShare = Pick<
  GenerationModelDetailFragment,
  'id' | 'media' | 'tags' | 'author'
>

const fixedShareTags = ['pixai']

const getShareButtonPropsForModel = (model: ModelForShare, t: TFunction) => {
  const tags = model.tags?.map(({ name }) => name).slice(0, 5) ?? []

  return {
    link: getModelShareLink(model.id),
    image: getPublicUrl(model.media),
    text: t('market:model.social-share-text', {
      authorName: `${
        model.author?.username ||
        getUserDisplayName(model.author) ||
        'anonymous'
      }`,
    }),
    tags: [...fixedShareTags, ...tags],
  }
}

export function dialogModelShareCard(model: ModelForShare, t: TFunction) {
  return UIDialog.create({
    dismissable: true,
    children: (
      <div className="p-5 pb-6 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-xl leading-none pb-1 font-sans">Share</div>
            {model.author?.username && (
              <div className="text-xs">Model by @{model.author?.username}</div>
            )}
          </div>

          {!!navigator.share && (
            <SystemShareButton {...getShareButtonPropsForModel(model, t)} />
          )}
        </div>

        <SocialShare {...getShareButtonPropsForModel(model, t)} />
      </div>
    ),
  })
}
